import styled from 'styled-components'

const Carousel = (props) => {
  const { children } = props
  return <ContentView>{children}</ContentView>
}

const ContentView = styled.div`
  width: 100%;
  height: 120px;
  padding: 0px 24px 0px 0px;
  display: flex;
  overflow: auto;
  background-color: transparent;
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
`

export default Carousel
